import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    height: '100%',
    paddingRight: 0,
    paddingLeft: 0,
    marginLeft: 0,
    marginBottom: 0,
    scrollBehavior: 'unset',
    backgroundColor: '#BBBAAA',
  },
  datePickerContainer: {
    display: 'flex',
    flex: 1,
    flexWrap: 'wrap',
    flexDirection: 'row',
    justifyContent: 'space-around',
    alignItems: 'center',
    marginBottom: 16,
  },
  drawerIsClosed: {
    left: 48,
  },
  drawerIsOpen: {
    left: 240,
  },
  createOrderButton: {
    position: 'absolute',
    top: 88,
    left: 48,
    backgroundColor: theme.palette.background.default,
    borderRadius: 32,
    marginLeft: 24,
    marginTop: 24,
  },
  bottomNavigation: {
    width: '100%',
    position: 'fixed',
    bottom: 0,
    left: 0,
    zIndex: 99999,
    backgroundColor: theme.palette.primary.main,
  },
  bottomNavLabel: {
    color: theme.palette.common.white,
  },
}));
